import Proxy from "../proxies/Proxy";
import BaseProxy from '../proxies/Proxy'

export default class CompanyProxy extends BaseProxy {
  /**
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    parameters.client = "front";
    super("companies", parameters);
  }

  getCategories() {
    return this.submit("get", `/categories/allCategories`);
  }

  publish(id, config = {}) {
    return this.submit(
      "PUT",
      `${this.endpoint}/${id}/status/published`,
      null,
      config
    );
  }

  deactivate(id, config = {}) {
    return this.submit(
      "PUT",
      `${this.endpoint}/${id}/status/inactive`,
      null,
      config
    );
  }
}
